import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { kaneoheConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={kaneoheConfig} />;
}